import React from 'react';
import { Form, FormField } from '../../../shared/components/form_components/form';
import { InputForm } from '../../../shared/components/form_components/input';

interface Props {
  horario?: FormHorario;
  onSubmit: (horario: FormHorario) => void;
  onCancel?: () => void;
}

interface FormHorario {
  id_horario?: number;
  hora_inicio: string;
  hora_fim: string;
}

const FormularioHorario: React.FC<Props> = (props) => {
  const fields: FormField[] = [
    {
      name: 'id_horario',
      label: 'Id do horário',
      type: 'number',
      defaultValue: props.horario?.id_horario,
      required: true,
      disabled: true,
      component: InputForm,
    },
    {
      name: 'hora_inicio',
      label: 'Hora início',
      type: 'time',
      defaultValue: props.horario?.hora_inicio,
      required: true,
      component: InputForm,
    },
    {
      name: 'hora_fim',
      label: 'Hora fim',
      type: 'time',
      defaultValue: props.horario?.hora_fim,
      required: true,
      component: InputForm,
    },
  ];

  return (
    <Form
      fields={fields}
      form_name='horário'
      is_edit={Boolean(props.horario)}
      onSubmit={props.onSubmit}
      onCancel={props.onCancel}
    />
  );
};

export { FormularioHorario };
export type { FormHorario };
